import { isValidFullName, isValidZipCode } from '@brands/Utils/validation';
import * as Yup from 'yup';

/**
 * Same rules as EditCreditCardModal's schema, except the billing-address
 * fields only apply when the patient picked "Use a different billing
 * address" — with "Current address" selected those inputs aren't rendered and
 * the address is read off the profile on file instead, so validating them
 * would block the form on inputs nobody can see.
 */
export const validationSchema = (requireManualBillingAddress: boolean): any => {
  return Yup.object().shape({
    creditCardFullName: Yup.string().test('creditCardFullName', 'Full Name on card is required', function (value) {
      if (!value) {
        return false;
      }
      if (!isValidFullName(value)) {
        return this.createError({
          message: 'Please enter a valid Full Name',
        });
      }
      return true;
    }),
    ...(requireManualBillingAddress
      ? {
          creditCardAddress1: Yup.string().trim().required('Address is required'),
          creditCardCity: Yup.string().trim().required('City is required'),
          creditCardState: Yup.string().trim().required('State is required'),
          creditCardZipCode: Yup.string()
            .trim()
            .required('Zip Code is required')
            .test('creditCardZipCode', 'Not valid zipcode', (value) => !value || isValidZipCode(value)),
        }
      : {}),
  });
};

export default validationSchema;
